@if (!plain && !range) {
  <div class="mbs-input mbs-datepicker_input">
    @if (label && id) {
      <mbs-input-label
        [boldLabel]="boldLabel"
        [disabled]="disabledState"
        [id]="id"
        [info]="info"
        [infoContainer]="infoContainer"
        [infoPlacement]="infoPlacement"
        [infoTriggers]="infoTriggers"
        [label]="label"
        [labelClasses]="labelClasses"
        [labelContentClasses]="labelContentClasses"
        [labelSize]="labelSize"
        [required]="hasRequiredValidator && showRequiredMark">
        <ng-content
          ngProjectAs="[prependLabel]"
          select="[prependLabel]" />
        <ng-content
          ngProjectAs="[appendLabel]"
          select="[appendLabel]" />
      </mbs-input-label>
    }

    <div class="input-group mbs-datepicker_input-group">
      @if (prependButtons || prepend) {
        <mbs-input-pre-append
          [data]="prependButtons"
          [dataTemplate]="prepend"
          [disabled]="disabledState"
          [position]="'prepend'"
          [size]="buttonsSize"
          (buttonClick)="buttonClickPrepend.emit($event)"
          (keyupEnter)="handleButtonEnter()" />
      }

      @if (viewMode === DatepickerViewMode.month) {
        <div
          #dropdown="ngbDropdown"
          ngbDropdown
          class="input-group_control flex-grow-1 mbs-datepicker_input-group_control"
          [autoClose]="autoClose"
          [container]="container"
          [ngClass]="[size ? 'input-group_control-' + size : '']"
          [placement]="placement"
          (openChange)="onOpenChange($event)">
          <input
            ngbDropdownToggle
            class="form-control"
            [attr.aria-describedby]="id"
            [attr.aria-labelledby]="label"
            [autocomplete]="'off'"
            [disabled]="disabledState"
            [id]="id"
            [name]="name"
            [ngClass]="[size ? 'form-control-' + size : '', isValidated ? bindClasses : '']"
            [placeholder]="placeholder"
            [readonly]="readonlyState"
            [tabindex]="tabindex"
            [value]="date"
            (blur)="handleBlur($event)"
            (change)="handleChange($event)"
            (click)="handleClick($event)"
            (focus)="handleFocus($event)" />

          <div
            #dropdownMenu
            ngbDropdownMenu
            class="mbs-datepicker_dropdown -arrow">
            <ngb-datepicker
              #datepicker
              class="mbs-datepicker_datepicker"
              [dayTemplate]="customDay"
              [displayMonths]="displayMonths"
              [firstDayOfWeek]="firstDayOfWeek"
              [footerTemplate]="footerTemplate"
              [markDisabled]="markDisabled"
              [maxDate]="dateAdapter.fromModel(maxDate)"
              [minDate]="dateAdapter.fromModel(minDate)"
              [navigation]="navigation"
              [outsideDays]="outsideDays"
              [showWeekNumbers]="showWeekNumbers"
              [startDate]="startDate"
              [weekdays]="showWeekdays"
              [(ngModel)]="date"
              (navigate)="onNavigate($event)"
              (select)="handleSelect($event)" />
          </div>

          @if (loading) {
            <ng-container [ngTemplateOutlet]="loaderTemplate" />
          }
        </div>
      }

      @if (viewMode === DatepickerViewMode.year) {
        <div
          #dropdown="ngbDropdown"
          ngbDropdown
          class="input-group_control flex-grow-1 mbs-datepicker_input-group_control"
          [autoClose]="autoClose"
          [container]="container"
          [ngClass]="[size ? 'input-group_control-' + size : '']"
          [placement]="placement">
          <input
            ngbDropdownToggle
            class="form-control"
            [attr.aria-describedby]="id"
            [attr.aria-labelledby]="label"
            [autocomplete]="'off'"
            [disabled]="disabledState"
            [id]="id"
            [name]="name"
            [ngClass]="[size ? 'form-control-' + size : '', isValidated ? bindClasses : '']"
            [placeholder]="placeholder"
            [readonly]="readonlyState"
            [tabindex]="tabindex"
            [value]="date"
            (blur)="handleBlur($event)"
            (change)="handleChange($event)"
            (click)="handleClick($event)"
            (focus)="handleFocus($event)" />

          @if (showButtonInside && date) {
            <mbs-button
              class="form-control_clear"
              tabindex="-1"
              [buttonType]="'reset'"
              [customClasses]="'form-control_clear-btn' + (size ? ' -' + size : '')"
              [icon]="'ico ico-Delete-text mr-0'"
              [isCtrl]="true"
              [ngClass]="size ? '-' + size : ''"
              [size]="size"
              [type]="'dark'"
              (click)="handleClear()" />
          }

          <div
            #dropdownMenu
            ngbDropdownMenu
            class="mbs-datepicker_dropdown -arrow">
            <ngb-datepicker
              #datepicker
              class="mbs-datepicker_datepicker -year"
              [displayMonths]="12"
              [footerTemplate]="footerTemplateYear"
              [maxDate]="dateAdapter.fromModel(maxDate)"
              [minDate]="dateAdapter.fromModel(minDate)"
              [startDate]="startDate"
              [weekdays]="false"
              [(ngModel)]="date"
              (navigate)="onNavigate($event)"
              (select)="handleSelect($event)">
              <ng-template ngbDatepickerContent>
                <div class="mbs-datepicker_datepicker-months">
                  @for (month of monthList$.asObservable() | async; track month) {
                    <button
                      ngbDropdownItem
                      class="mbs-datepicker_datepicker-month"
                      [class.-current]="isTodayMonth(month)"
                      [class.-disabled]="isDisabledMonth(month)"
                      [class.-selected]="isSelectedMonth(month)"
                      (click)="handleMonthSelect(month)">
                      {{ i18n.getMonthShortName(month.month) }}
                      <ngb-datepicker-month
                        class="d-none"
                        [month]="month" />
                    </button>
                  }
                </div>
              </ng-template>
            </ngb-datepicker>
          </div>

          @if (loading) {
            <ng-container [ngTemplateOutlet]="loaderTemplate" />
          }
        </div>
      }

      @if (!showButtonInside) {
        <mbs-input-pre-append
          [dataTemplate]="append"
          [data]="[
            {
              icon: 'ico ico-Calendar',
              type: 'secondary'
            }
          ]"
          [disabled]="disabledState"
          [position]="'append'"
          [size]="buttonsSize"
          (buttonClick)="handleButtonClick($event)"
          (keyupEnter)="handleButtonEnter()" />
      }

      @if (appendButtons || append) {
        <mbs-input-pre-append
          [data]="appendButtons"
          [dataTemplate]="append"
          [disabled]="disabledState"
          [position]="'append'"
          [size]="buttonsSize"
          (buttonClick)="buttonClickAppend.emit($event)"
          (keyupEnter)="handleButtonEnter()" />
      }
    </div>

    @if (isShowErrors) {
      <mbs-input-errors [errors]="errors" />
    }
  </div>
}

@if (plain) {
  <ngb-datepicker
    #datepicker
    class="mbs-datepicker_datepicker -plain"
    [dayTemplate]="dayTemplate || customDay"
    [disabled]="disabledState"
    [displayMonths]="displayMonths"
    [firstDayOfWeek]="firstDayOfWeek"
    [footerTemplate]="hideFooter ? null : footerTemplate"
    [id]="id"
    [markDisabled]="markDisabled"
    [maxDate]="dateAdapter.fromModel(maxDate)"
    [minDate]="dateAdapter.fromModel(minDate)"
    [ngModel]="date"
    [navigation]="navigation"
    [outsideDays]="outsideDays"
    [showWeekNumbers]="showWeekNumbers"
    [startDate]="startDate"
    (dateSelect)="handleChange($event)"
    (navigate)="onNavigate($event)" />
}

@if (range) {
  <ngb-datepicker
    #datepicker
    class="mbs-datepicker_datepicker -plain"
    [dayTemplate]="dayTemplate || rangeDay"
    [disabled]="disabledState"
    [displayMonths]="2"
    [firstDayOfWeek]="firstDayOfWeek"
    [footerTemplate]="hideFooter ? null : footerTemplate"
    [id]="id"
    [markDisabled]="markDisabled"
    [maxDate]="dateAdapter.fromModel(maxDate)"
    [minDate]="dateAdapter.fromModel(minDate)"
    [navigation]="navigation"
    [ngModel]="date"
    [outsideDays]="outsideDays"
    [showWeekNumbers]="showWeekNumbers"
    [startDate]="startDate"
    [weekdays]="showWeekdays"
    (dateSelect)="onDateSelection($event)"
    (navigate)="onNavigate($event)"
    (select)="handleSelect($event)" />
}

<ng-template
  #rangeDay
  let-date
  let-focused="focused">
  <span
    class="mbs-datepicker_datepicker-day"
    [class.faded]="isHovered(date) || isInside(date)"
    [class.focused]="focused"
    [class.range]="isRange(date)"
    (mouseenter)="hoveredDate = date"
    (mouseleave)="hoveredDate = null">
    {{ date.day }}
  </span>
</ng-template>

<ng-template
  #customDay
  let-currentMonth="currentMonth"
  let-date
  let-disabled="disabled"
  let-focused="focused"
  let-today="today">
  <span
    class="mbs-datepicker_datepicker-day"
    [class.-disabled]="disabled"
    [class.-focused]="focused"
    [class.-outside]="date.month !== currentMonth"
    [class.-selectted]="isSelected(date)"
    [class.-today]="today"
    [class.-weekend]="isWeekend(date)">
    {{ date.day }}
  </span>
</ng-template>

<ng-template #footerTemplate>
  <footer class="mbs-datepicker_datepicker-footer">
    <mbs-button
      [isCtrl]="true"
      [size]="MbsSize.xs"
      [type]="'primary'"
      (click)="handleSetToday()">
      Currently: {{ currentDate | date: 'mediumDate' }}
    </mbs-button>
  </footer>
</ng-template>

<ng-template #footerTemplateYear>
  <footer class="mbs-datepicker_datepicker-footer">
    <mbs-button
      [isCtrl]="true"
      [size]="MbsSize.xs"
      [type]="'primary'"
      (click)="handleSetToYears()">
      Currently: {{ currentDate | date: 'MMMM, yyyy' }}
    </mbs-button>
  </footer>
</ng-template>

<ng-template #loaderTemplate>
  <div class="loader-container">
    <span class="loader"></span>
  </div>
</ng-template>
